import i18n from "../i18n";

export const getNextProjectState = (state) => {
  let newState = "";
  switch (state) {
    case "in_configuration":
      newState = "in_testing";
      break;
    case "in_testing":
      newState = "in_evaluation";
      break;
    case "in_evaluation":
      newState = "completed";
      break;
  }
  return newState;
};

export const getProjectStatePresentationName = (state) => {
  return state ? i18n.t(`project_list.state.${state}`) : "";
};

export const getProjectStateChangeModalTitle = (state) => {
  return state ? i18n.t(`project.change_state.modal.${state}.title`) : "";
};

export const getProjectStateChangeModalText = (state) => {
  return state ? i18n.t(`project.change_state.modal.${state}.text`) : "";
};

export const getProjectStateChangeModalPrimaryButtonText = (state) => {
  return state ? i18n.t(`project.change_state.modal.${state}.button`) : "";
};
